export const isMobile = () => {
  return window.innerWidth <= 1000;
};
